import { useNavigate } from "react-router-dom";

import { SimulatorChannelIcon } from "@/routes/simulators/SimulatorChannelIcon";
import { Navbar } from "@/components/shared/navbar/Navbar";
import { useSimulator } from "../simulator/context/SimulatorWrapper";
import { AiBrowser } from "@/v2/assets/icons/AiBrowser";
import { Ticket03Icon } from "@/v2/assets/icons/Ticket03Icon";
import { Comment01Icon } from "@/v2/assets/icons/Comment01Icon";
import { Rotate3d } from "@/v2/assets/icons/3dRotate";
import { SidebarRight } from "@/v2/assets/icons/SidebarRight";
import { Slack } from "@/v2/assets/icons/Slack";
import { SimulatorChannel } from "@/api/simulator/simulator.model";

function getChannelIconWithContainer(channel: SimulatorChannel) {
  const getIcon = () => {
    switch (channel) {
      case "autonomous_ticket_event":
        return <Ticket03Icon size={16} fill="blue" />;
      case "autonomous_quackchat":
        return <Comment01Icon size={16} fill="orange" />;
      case "copilot":
        return <SidebarRight size={16} fill="teal" />;
      case "slackbot":
        return <Slack size={16} fill="purple" />;
      case "knowledge_hub":
        return <Rotate3d size={16} fill="cyan" />;
      default:
        return null;
    }
  };

  const getBackgroundColor = () => {
    switch (channel) {
      case "autonomous_ticket_event":
        return "#EDF6FF";
      case "autonomous_quackchat":
        return "rgba(255, 145, 1, 0.165)";
      case "copilot":
        return "rgba(2, 192, 150, 0.095)";
      case "slackbot":
        return "#FCEFFC";
      case "knowledge_hub":
        return "rgba(1, 204, 255, 0.114)";
      default:
        return "transparent";
    }
  };

  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: getBackgroundColor(),
        borderRadius: "4px",
      }}
    >
      {getIcon()}
    </div>
  );
}

export const VersionsNavBar = ({ versionIndex }: { versionIndex?: number }) => {
  const navigate = useNavigate();
  const { simulator } = useSimulator();

  if (versionIndex) {
    return (
      <div className="flex items-center p-3 border-b">
        <Navbar
          items={[
            ...(simulator != null
              ? [
                  {
                    title: simulator.name,
                    svg: getChannelIconWithContainer(simulator.channel),
                    onClick: () => navigate(`/automation/${simulator.id}`),
                  },
                ]
              : []),
            { title: "Versions" },
          ]}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center p-3 border-b">
      <Navbar
        items={[
          ...(simulator != null
            ? [
                {
                  title: simulator.name,
                  svg: getChannelIconWithContainer(simulator.channel),
                  onClick: () => navigate(`/automation/${simulator.id}`),
                },
              ]
            : []),
          {
            title: "Versions",
            onClick: () => navigate(`/automation/${simulator?.id}/versions`),
          },
        ]}
      />
    </div>
  );
};
